module.exports = __webpack_public_path__ + "static/media/Skin_tone_4.3c017ef0.svg";